import { FotoPerfil } from './styles';

const Avatar = () => {
  return (
    <>
      <FotoPerfil
        src="https://github.com/matheus-reichemback-stang.png"
        alt="Avatar do perfil"
      />
    </>
  );
};
export default Avatar;
